import React from 'react';
import { useReferencedComponent } from '@hooks/useReferencedComponent';
import { ArticleBlockContentGridCol } from '../components/ArticleBlockContentGridCol/ArticleBlockContentGridCol';
import { BlockContentContext } from '../../BlockContent.utils';
import {
  ReferencedComponentBlock,
  ReferencedComponentContent,
  ReferencedComponentData,
  ReferencedComponentSerializerProps,
} from '../components/ReferencedComponentSerializer/ReferencedComponentSerializer';

export const ReferencedComponentSerializer = (context: BlockContentContext = BlockContentContext.Stripped) => {
  const ArticleBlockContent = ({ value }: ReferencedComponentSerializerProps) => {
    // Fetched here and passed down, so it is fetched once.
    const data = useReferencedComponent(value.documentId) as ReferencedComponentData | null;

    if (data?.type === 'bodyFeaturedVehicleTestResult') {
      return <ReferencedComponentContent data={data} />;
    }

    return (
      <ArticleBlockContentGridCol>
        <ReferencedComponentContent data={data} />
      </ArticleBlockContentGridCol>
    );
  };

  if (context === BlockContentContext.Article) {
    return ArticleBlockContent;
  }

  return ({ value }: ReferencedComponentSerializerProps) => <ReferencedComponentBlock value={value} />;
};
